/**
 * 一个通用的 axios 实例
 */

import { axios, challengeKeyInterceptor, restfulTransformInterceptor, dataStringInterceptor } from '@douban/fe-utils'
import type { AxiosResponse } from 'axios';

const axiosInstance = axios.create({
  withCredentials: true,
  // headers: {
  //   'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
  //   'frodotk': "99dc9729e6a1ecb0cd95c57db3e5c610"
  // },
})
// axiosInstance.interceptors.request.use(dataStringInterceptor);
axiosInstance.interceptors.request.use(challengeKeyInterceptor)
axiosInstance.interceptors.request.use(restfulTransformInterceptor)

export default axiosInstance

export type FrodoResponseError = {
  localized_message?: string
  msg?: string
}
export type ServiceError<E = FrodoResponseError> = {
  response: AxiosResponse<E>
}
export type ServiceReject<E = FrodoResponseError> = [false, AxiosResponse<E>];
export type ServiceResolve<T = unknown> = [boolean, T]

export type ServiceResult<T = unknown, E = unknown> = Promise<ServiceResolve<T>|ServiceReject<E>>
